module.exports = __webpack_public_path__ + "static/Xenios40-fc61792c5363e9e95c7dafcc2c626870.webm";